import { useTranslate } from 'react-polyglot'
import { AlertPreset } from '~/@types/alert'

import { useAlertContext } from '@unlikelystudio/react-abstract-components'

import { ALERT } from '~/data/dictionary'

export default function useAlerts() {
  const { triggerAlert } = useAlertContext()
  const t = useTranslate()

  const getPreset = (preset: AlertPreset = 'SERVER_ERROR') => {
    switch (preset) {
      case 'ENTITY_SAVED':
      case 'EMAIL_SENT':
      case 'NEWSLETTER_SUBSCRIBE':
      case 'ALERT_STOCK_SUCCESS':
        return {
          title: t(ALERT.SUCCESS_TITLE),
          message: t(ALERT?.[preset] ?? preset),
          type: 'success',
        }
      case 'CHECKOUT_NOTE_ERROR':
        return {
          title: t(ALERT.ERROR_TITLE),
          message: t(ALERT?.[preset] ?? preset),
          type: 'success',
        }
      case 'COPY_SUCCESS':
        return {
          title: t(ALERT.COPY_SUCCESS_TITLE),
          type: 'success',
        }
      case "ADDED_WISHLIST":
        return {
          title: t(ALERT.ADDED_WISHLIST),
          type: 'success',
        }
      case "REMOVED_WISHLIST":
        return {
          title: t(ALERT.REMOVED_WISHLIST),
          type: 'success',
        }
      default:
        return {
          title: t(ALERT.ERROR_TITLE),
          message: t(ALERT?.[preset] ?? preset),
          type: 'error',
        }
    }
  }

  return (preset?: AlertPreset) => {
    triggerAlert(getPreset(preset))
  }
}
